import {pick} from 'lodash'
import update from 'immutability-helper'
import React from 'react'
import Modal from 'react-modal'
import Text from 'react-text'
import {Context} from '../../context'
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import './index.styl'

function Buttons ({buttonProps}) {
  const buttons = buttonProps.map((props, index) => {
    return (
      <button key={index} className={props.label} onClick={props.onClick}>
        <Text id={props.label} />
      </button>
    )
  })
  return (
    <div className="buttons" style={{display: "flex"}}>
      {buttons}
    </div>
  )
}

export default class AddResourceLink extends React.Component {

  static contextType = Context

  constructor (props) {
    super(props)
    const setState = this.setState.bind(this)
    this.state = {
      isOpen: true,
      title: '',
      href: '',
      setState
    }
  }

  render () {

    const context = this.context
    const template = context.query.template
    const {newPlan, navigate} = context
    const {content = {}} = newPlan
    const {resources: planResources = []} = content
    const {setState, isOpen} = this.state
    const close = () => setState({isOpen: false})
    const navigateOut = () => {
      context.navigate({}, context.match.path.replace(/\/:section.*$/,''), {query: {template}})
    }
    const create = () => {
      const href = /^http[s]*:\/\//.test(this.state.href) ? this.state.href : `http://${this.state.href}`
      const resources = update(planResources, {$push: [{type: 'link', title: this.state.title, href}]})
      context.setState({newPlan: {...newPlan, content: {...content, resources}}}, close)
    }
    return (
      <Modal
        isOpen={isOpen}
        onAfterClose={navigateOut}
        onRequestClose={close}
        contentLabel=""
        className="add-link-resource-wrapper"
        appElement={document.querySelector('#root')}
        closeTimeoutMS={800}
        >
          <div className="add-link-resource">
            <div className="title">
              <div className="label">
                <Text id="resource" />: <Text id="link" />
              </div>
              <div className="close" onClick={() => close()}>
                <FontAwesomeIcon icon={faTimesCircle} />
              </div>
            </div>
            <div className="content">
              <div className="form">
                <div className="name">
                  <label><Text id="title" /></label>
                  <input value={this.state.title} onChange={e => setState({title: e.target.value})} />
                </div>
                <div className="link">
                  <label><Text id="link" /></label>
                  <input value={this.state.href} onChange={e => setState({href: e.target.value})} />
                </div>
              </div>
              <Buttons buttonProps={[
                {label: 'cancel', onClick: close, enabled: true},
                {label: 'create', onClick: create, enabled: true}
              ]} />
            </div>
          </div>
        </Modal>
    )
  }
}
